import { ITeamMessage } from '../../../../types/ApiTypes';

export interface ApiTeamRef {
  user: {
    id: number;
    email: string | null;
  };
  teamName: string | null;
}

// The API serializes the conversation side three ways: a team ref for a game
// participant, a role string (e.g. 'global_admin') for an admin account, or no
// field at all for a participant it couldn't resolve. Only the first has a team
// to attach the message to (GMT-814) — messages on the other two are dropped
// before they reach ITeamMessage, so team.id stays required.
//
// Checks for `user` itself (not just its presence as a key) so an unexpected
// shape — e.g. `{}` or `[]`, both `typeof === 'object'` — is treated the same
// as the string/undefined cases instead of passing the guard and then crashing
// on `team.user.id` in toTeamMessage below (the exact class of bug this PR
// exists to fix, just one level deeper).
export const hasTeamRef = (party: ApiTeamRef | string | undefined): party is ApiTeamRef =>
  typeof party === 'object' && party !== null && !Array.isArray(party) && party.user != null;

interface ApiMessageBase {
  createdAt: string;
  game: number;
  id: number;
  message: string;
  wasRead: boolean;
}

export const toTeamMessage = (apiMessage: ApiMessageBase, team: ApiTeamRef, isReceived: boolean): ITeamMessage => ({
  createdAt: new Date(apiMessage.createdAt),
  gameId: apiMessage.game,
  id: apiMessage.id,
  message: apiMessage.message,
  team: {
    id: team.user.id,
    email: team.user.email,
    name: team.teamName,
  },
  isReceived,
  wasRead: apiMessage.wasRead,
});
